// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.aal-history {
  grid-template-columns: repeat(4, auto);
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/aal-manager/aal-manager.component.less"],"names":[],"mappings":"AAAA;EACI,sCAAA;AACJ","sourcesContent":[".grid.aal-history {\n    grid-template-columns: repeat(4, auto);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
